import React, { Component } from 'react';
import { adminUserService } from 'services/adminUser';
import { alertActions } from 'redux/actions/alert-actions';
import { connect } from 'react-redux';

class TwoFactorVerify extends Component {
    constructor(props) {
        super(props);
        this.state = {
            totp_code: '',
            submitting: false,
            submitted: false,
            remember_device: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, type, checked, value } = e.target;
        this.setState({ [name]: type === 'checkbox' ? checked : value });
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({ submitted: true });
        const { totp_code, remember_device } = this.state;
        if (!totp_code || this.state.submitting) {
            return;
        }
        this.setState({ submitting: true });
        adminUserService.twoFaVerify(this.props.challengeToken, totp_code, remember_device)
            .then((response) => {
                this.setState({ submitting: false });
                if (response && response.token && this.props.onAuthenticated) {
                    this.props.onAuthenticated(response);
                }
            })
            .catch((error) => {
                this.setState({ submitting: false });
                this.props.dispatch(alertActions.error(error));
            });
    }

    render() {
        const { totp_code, submitting, submitted, remember_device } = this.state;
        const message = this.props.message || 'Enter the 6-digit code from your authenticator app.';
        return (
            <div>
                <p className="text-center">{message}</p>
                <form name="twoFaVerifyForm" onSubmit={this.handleSubmit}>
                    <div className={'form-group' + (submitted && !totp_code ? ' has-error' : '')}>
                        <input
                            type="text"
                            inputMode="numeric"
                            autoComplete="one-time-code"
                            placeholder="Enter 6-digit authenticator code"
                            className="form-control email_ctrl"
                            name="totp_code"
                            value={totp_code}
                            onChange={this.handleChange}
                        />
                        {submitted && !totp_code &&
                            <div className="help-block">Authenticator code is required.</div>
                        }
                    </div>
                    <div className="form-group">
                        <label>
                            <input
                                type="checkbox"
                                name="remember_device"
                                checked={remember_device}
                                onChange={this.handleChange}
                            />
                            {' '}Remember this device
                        </label>
                    </div>
                    <div className="form-group">
                        <button className="btn btn-default btn_login" disabled={submitting}>
                            {submitting ? 'VERIFYING...' : 'VERIFY'}
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

export default connect()(TwoFactorVerify);
